import React from "react";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditorProvider,
  RichTextField,
} from "mui-tiptap";

function TextEditor() {
  const editor = useEditor({
    extensions: [StarterKit],
    content: "",
  });
  return (
    <>
      <RichTextEditorProvider editor={editor}>
        <RichTextField
          className="mb-3"
          controls={
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuButtonOrderedList />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              {/* Add more controls of your choosing here */}
            </MenuControlsContainer>
          }
        />
      </RichTextEditorProvider>
    </>
  );
}

export default TextEditor;
